module.exports = __webpack_public_path__ + "static/media/ko.8a067f19.svg";